import { render, staticRenderFns } from "./SSLCertificateTab.vue?vue&type=template&id=65e485a4&scoped=true&"
import script from "./SSLCertificateTab.vue?vue&type=script&lang=js&"
export * from "./SSLCertificateTab.vue?vue&type=script&lang=js&"
import style0 from "./SSLCertificateTab.vue?vue&type=style&index=0&id=65e485a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e485a4",
  null
  
)

export default component.exports